// extracted by mini-css-extract-plugin
export default {"content":"FooterCellContent_content__4grFL","center":"FooterCellContent_center__3gcq8","left":"FooterCellContent_left__fwvep","right":"FooterCellContent_right__5cJdW"};